const initialState = {
  fetching: false,
};

export default function multiTemplateReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'MULTI_TEMPLATE_ADDING':
      return { ...currentState, fetching: true };
    case 'MULTI_TEMPLATE_ADDED':
      return { ...currentState, fetching: false };
    case 'MULTI_TEMPLATE_FETCHING':
      return { ...currentState, fetching: true };
    case 'MULTI_TEMPLATE_PAGE_FETCHING':
      return { ...currentState, fetching: true };
    case 'MULTI_TEMPLATE_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'MULTI_TEMPLATE_PAGE_FETCHED':
      return { ...currentState, page: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
